import { createFileRoute, Link } from "@tanstack/react-router";
import { buildSeo } from "@/lib/seo";
import { useTranslation } from "react-i18next";
import { MarketingLayout, SectionHeader, I18nPageHero } from "@/components/marketing/Layout";

export const Route = createFileRoute("/network")({
 head: () => buildSeo({
 path: "/network",
 title: "The Network — Reality Twin",
 description: "The Reality Twin Network is a marketplace of AI Twins where companies can be discovered by customers, partners and AI assistants.",
 }),
 component: NetworkPage,
});

function NetworkPage() {
 const { t } = useTranslation();
 return (
 <MarketingLayout>
 <I18nPageHero tKey="pages.network" />

 <section className="border-b border-border py-16">
 <div className="mx-auto max-w-3xl px-6 space-y-5 text-[16px] leading-[1.7] text-muted-foreground">
 <p>{t("routes.network.p1")}</p>
 <p>{t("routes.network.p2")}</p>
 </div>
 </section>

 <section className="py-20">
 <div className="mx-auto max-w-3xl px-6">
 <div className="hairline rounded-2xl bg-card p-10 sm:p-14 text-center">
 <div className="mx-auto h-16 w-16 rounded-2xl bg-cream hairline flex items-center justify-center">
 <div className="h-2 w-2 rounded-full bg-foreground animate-pulse" />
 </div>
 <h2 className="mt-6 font-serif text-[32px] sm:text-[40px] leading-[1.05] tracking-[-0.025em]">
 {t("routes.network.soonA")}<br /><em className="italic text-muted-foreground">{t("routes.network.soonEm")}</em>
 </h2>
 <p className="mt-5 text-[15px] text-muted-foreground max-w-md mx-auto">{t("routes.network.soonSub")}</p>
 <Link to="/auth" className="mt-8 inline-flex items-center gap-1.5 rounded-full bg-foreground px-5 py-3 text-[14px] font-medium text-background hover:opacity-90 transition">
 {t("routes.network.soonCta")}
 </Link>
 </div>
 </div>
 </section>

 <section className="bg-cream border-y border-border py-24">
 <div className="mx-auto max-w-6xl px-6">
 <SectionHeader
 eyebrow={t("routes.network.twinEyebrow")}
 title={<>{t("routes.network.twinTitleA")}<em className="italic text-muted-foreground">{t("routes.network.twinTitleEm")}</em></>}
 sub={t("routes.network.twinSub")}
 />
 </div>
 </section>
 </MarketingLayout>
 );
}
